/**
 * <ModalContent />
 *
 * @parent Modal
 * @stateless
 */
import React, { PropTypes, Component } from 'react';
import Form from 'components/Form';
import { ADD_CREDIT, CHARGE, REFUND, REFUND_CREDIT } from "./index";
import schemaLeftFactory from "./schemaLeft";
import schemaRightFactory from "./schemaRight";

import locale from './locale'
import "./Modal.scss";


class ModalContent extends Component {
  constructor(props){
    super(props)

    this.state = {
      formData: {},
      paymentType: this.props.paymentType || ADD_CREDIT,
    }

    this.onChange = this.onChange.bind(this)
    this.changePaymentType = this.changePaymentType.bind(this)
  }

  onChange(formData) {
    this.setState({
      formData:{
        ...this.state.formData,
        ...formData
      }
    }, () => {
      this.props.onFormChange(formData)
    })
  }

  changePaymentType(e) {
    this.setState({
      paymentType: e.target.value,
      formData: {}
    }, () => {
      this.props.onFormChange(this.state.formData)
      this.props.changePaymentType(this.state.paymentType);
    });
  }

  render() {
    const {formData, paymentType} = this.state;
    const {student} = this.props;
    let schemaLeft = schemaLeftFactory.call(this, paymentType);
    let schemaRight = schemaRightFactory.call(this, paymentType);

    return (
      <div className='new-payment-modal-content'>
        <div className='content'>
          <div className='sleeve'>
            { (paymentType === REFUND || paymentType == REFUND_CREDIT) &&
              <div>
                <div className='col-sm-6'>
                  <label className='control'>
                    <input type='radio' name='charge_type' value={REFUND} checked={paymentType===REFUND} onChange={this.changePaymentType} />
                    {__('Refund Class Fee', locale)}
                    <span className='radiomark'></span>
                  </label>
                  <p>
                    {__('Refund the paid fee for this student', 'PaymentModal.refund')}
                  </p>
                </div>

                <div className='col-sm-6'>
                  <label className='control'>
                    <input type='radio' name='charge_type' value={REFUND_CREDIT} disabled={student.balance <= 0 ? true : false} checked={paymentType===REFUND_CREDIT} onChange={this.changePaymentType} />
                    {__('Refund Credits', locale)}
                    <span className='radiomark'></span>
                  </label>
                  <p>
                    {__('Refund the collected credit for this student', 'PaymentModal.refund')}
                  </p>
                </div>
              </div>
            }

            { (paymentType !== REFUND && paymentType !== REFUND_CREDIT) &&
            <div className='col-sm-6'>
              <label className='control'>
                <input type='radio' name='charge_type' value={ADD_CREDIT} checked={paymentType===ADD_CREDIT} onChange={this.changePaymentType} />
                {__('Add Credit', 'student')}
                <span className='radiomark'></span>
              </label>
              <p>
                {__("Add the credit to the student's account and can be used towards other expenses", 'student')}
              </p>
            </div> }

            { (student.classList && student.classList.length > 0 && (paymentType !== REFUND && paymentType !== REFUND_CREDIT)) &&
            <div className='col-sm-6' >
              <label className='control'>
                <input type='radio' name='charge_type' value={CHARGE} checked={paymentType===CHARGE} onChange={this.changePaymentType}/>
                {__('Charge', 'student')}
                <span className='radiomark'></span>
              </label>
              <p>
                {__('Collecting tuition fee and renewal', 'student')}
              </p>
            </div> }
          </div>
          <div className='row'>
            <div className='col-xs-6 schemaLeft'>
              <Form
                onChange={this.onChange}
                schema={schemaLeft}
                formData={formData}
                formStyle='outline'
                getValidationRef={this.props.getValidationRefLeft}
              />
            </div>
            <div className='col-xs-6 schemaRight'>
              <Form
                onChange={this.onChange}
                schema={schemaRight}
                formData={formData}
                formStyle='outline'
                getValidationRef={this.props.getValidationRefRight}
              />
            </div>

          </div>
        </div>
      </div>
    )
  }
}

export default ModalContent;



// WEBPACK FOOTER //
// ./src/template/Modals/NewPayment/ModalContent.js